'use strict';

/*global BasicQueue*/

function TransferNoteQueue(containerId) {
  BasicQueue.call(this, containerId);

  this.init();
}

TransferNoteQueue.prototype = $.extend({}, BasicQueue.prototype, {
  constructor: 'TransferNoteQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
